
import {
  IconCheckInCircle,
  RevButton,
  RevIllustration,
  RevLink,
  RevModal,
} from '@backmarket/design-system'

import { MODAL_NAMES } from '@config/constants'
import FormattedMessage from '@i18n/components/FormattedMessage'
import { trackClick } from '@tracking/events'

import translations from './PrepaidPlanModal.translations'

export default {
  components: {
    FormattedMessage,
    IconCheckInCircle,
    RevButton,
    RevIllustration,
    RevLink,
    RevModal,
  },
  computed: {
    modalName: () => MODAL_NAMES.PRODUCT.PREPAID_PLAN,
    translations: () => translations,
  },
  methods: {
    trackButtonClick() {
      trackClick({
        name: 'talk_US_mobile',
        page_type: this.$route.name,
        zone: 'mobile_plan',
      })
    },
  },
}
